import React from 'react';
import { useHistory } from 'react-router-dom';
import StatusBadge from '../../Common/StatusBadge';

const STATUS = {
  Draft: { label: 'Utkast', tone: 'muted' },
  Sent: { label: 'Skickad', tone: 'info' },
  Partially_Paid: { label: 'Delvis betald', tone: 'warning' },
  Paid: { label: 'Betald', tone: 'success' },
  Cancelled: { label: 'Makulerad', tone: 'muted' },
  Credited: { label: 'Krediterad', tone: 'info' },
};

const formatSek = (v) =>
  new Intl.NumberFormat('sv-SE', { style: 'currency', currency: 'SEK' }).format(Number(v) || 0);

/**
 * One customer's invoices, on the customer detail page. Rows are what
 * GET sales/customers/:id/invoices returns (invoicenumber, invoicedate,
 * deadline, total_with_tax, status, invoice_type). The endpoint carries no
 * is_overdue, so overdue is worked out here: still open and past its deadline.
 */
const InvoicesTable = ({ invoices, companyId }) => {
  const history = useHistory();
  const today = new Date().toISOString().slice(0, 10);

  return (
    <table className="ll-table ll-table--clickable">
      <thead>
        <tr>
          <th>Faktura</th>
          <th>Fakturadatum</th>
          <th>Förfaller</th>
          <th className="ll-num">Belopp</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        {invoices.map((inv) => {
          const status = STATUS[inv.status] || { label: inv.status, tone: 'muted' };
          const isCreditNote = inv.invoice_type === 'credit_note';
          const isOverdue = !isCreditNote
            && ['Sent', 'Partially_Paid'].includes(inv.status)
            && inv.deadline && inv.deadline < today;
          const amount = Math.abs(parseFloat(inv.total_with_tax) || 0);
          return (
            <tr key={inv.id} onClick={() => history.push(`/${companyId}/view-invoice-new/${inv.id}`)}>
              <td style={{ fontWeight: 600 }}>
                {inv.is_published ? (inv.invoicenumber || '–') : 'Utkast'}
                {isCreditNote && <span className="cust-detail__item-sub" style={{ fontWeight: 400 }}> · Kreditnota</span>}
              </td>
              <td>{inv.invoicedate || '–'}</td>
              <td>
                {inv.deadline || '–'}
                {isOverdue && <span className="cust-detail__overdue">Förfallen</span>}
              </td>
              <td className="ll-num">{isCreditNote ? '−' : ''}{formatSek(amount)}</td>
              <td><StatusBadge tone={status.tone}>{status.label}</StatusBadge></td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default InvoicesTable;
